import React from 'react'
import './VideoTab.scss'
const VideoTab = () => {
  return (
    <div>VideoTab</div>
  )
}

export default VideoTab